/**
 * QuizType
 * Enum representing quiz types.
 *
 * @property QUIZ - Quiz.
 * @property TEST - Test.
 * @property ASSIGNMENT - Assignment.
 */
export enum QuizType {
  QUIZ = 'quiz',
  TEST = 'test',
  ASSIGNMENT = 'assignment',
}
